import ServerConfigs from './server-config'

const Urls = {
    BASE_URL: ServerConfigs.url,
    CLAIMSIGNURL: "/api/school/signUrl",
    CHEATSHEETSIGNURL: "/api/school/signUrlForCheatSheet",
    COUNTINGWELL_CLASS: '/api/admin/class/list',
    COUNTINGWELL_BOARD: '/api/admin/board/list',
    CLASS_LIST: '/api/class/list',
    CITIES_LIST: '/api/cities/list',
    SECTION_LIST: '/api/section/list',
    SCHOOL_LIST: '/api/school/list',
    SKILLS_LIST: '/api/skills/list',
    SIGN_UP: '/api/school/authentication/signup',
    LOGIN: '/api/school/authentication/login',
    LOGOUT: '/api/school/authentication/logout',
    FORGOT_PASSWORD: '/api/school/authentication/forgot/password',
    RESET_PASSWORD: '/api/school/authentication/reset/password',
    CHANGE_PASSWORD: '/api/school/authentication/updatepassword',
    PROFILE: '/api/school/user/profile',
    IS_LOGGEDIN: '/api/school/user/isloggedin',
    COUNTRY_LIST: '/api/country/list',
    COUNTRY_LIST_ALL: '/api/school/country/list',
    STAFF_TYPE: '/api/school/staff/types',
    SCHOOL_CLASS: '/api/school/classandboard',
    SCHOOL_CLASS_PUBLIC: '/api/school/classandboard/public',
    STAFFS: '/api/school/staff',
    GET_STAFFS_WITH_ENGAGEMENT_SCORE: "/api/school/staffwithengagementscore",
    EVENTS_TO_COORDINATOR: '/api/school/staffs/event',
    CONFIRM_STAFF_PROFILE: "/api/school/staff/confirmprofile",
    STAFFS_INVITE: '/api/school/staff/invite',
    STUDENT_BULK_INVITE: '/api/school/user/invite/bulk',
    STUDENT_INVITE: '/api/school/user/invite',
    STAFFS_BULK: '/api/school/staff/bulk',
    SECTION: '/api/school/section',
    SECTION_PUBLIC: '/api/school/section/public',
    SECTION_BULK: '/api/school/section/bulk',
    SECTION_BULK_TEACHER: '/api/school/section/bulkbyteacher',
    ASSIGN_HOMEWORK: "/api/school/event/homework",
    ASSIGN_HOMEWORK_V2: "/api/school/homework/onetab",
    ASSIGN_HOMEWORK_V3: '/api/school/eventlive/homework',
    EVENT_LIVE_HOMEWORK_DETAIL: '/api/school/eventlive/homeworkdetail',

    MULTIPLE_SIGNED_URLS: '/api/school/staff/signUrl/multiple',

    HOMEWORK_SCHOOL_DETAILS: "/api/school/homework/schooldetails",
    SEND_HOMEWORK_NOTIFICATION: "/api/school/homework/notify/students",
    SCHOOL_USERS: '/api/school/schoolusers',
    SCHOOL_USERS_BULK_SECTION_ASSIGN: "/api/school/schoolusers/section/bulk",
    STUDENTS_LIST: '/api/school/users',
    SCHOOL_USERS_BULK: '/api/school/schoolusers/bulk',
    SCHOOL_NAME_LIST_AS_STUDENT_NAME_BULK: '/api/school/schoolsnamelistasstudentname/bulk',
    CHAPTER_LIST: '/api/school/chapterlist',
    ASSESSMENT_CHAPTER_LIST: '/api/school/assessment/chapterlist',
    ALL_CLASS_CHAPTER_LIST: '/api/school/allclasschapterlist',
    ELO_LIST: "/api/school/elolist",
    HOMEWORK: "/api/school/homework",
    UPDATE_STAFF_SUBJECT_INFO: "/api/school/staff/subjectinfo",
    HOMEWORK_DETAIL_FOR_LINK: "/api/school/homework/detail/link",
    CREATE_HOMEWORK_FOR_LINK: "/api/school/homework/create/link",
    HOMEWORK_QUESTION_CATEGORY: "/api/school/homework/questioncategory",
    ADAPTIVE_HOMEWORK: "/api/school/homework/adaptive",
    HOMEWORK_DEEP_LINK: "/api/school/homework/deeplink",
    HOMEWORK_REMINDER: "/api/school/homework/reminder",
    WORKFLOW_NODES: "/api/school/workflownodes",
    SCHOOL: "/api/school",
    HOMEWORK_DOWNLOAD_REPORT: '/api/school/homework/report/pdf',
    HOMEWORK_COMPLETION_REPORT: '/api/school/homework/completionreport',
    HOMEWORK_EVALUATION_REPORT: '/api/school/homework/evaluationreport',
    HOMEWORK_LEVEL_PROGRESSION_REPORT: '/api/school/homework/level/progression/report',
    HOMEWORK_STUDENT_DETAIL_REPORT: '/api/school/homework/studentdetailreport',
    HOMEWORK_WRONG_ANSWERS_REPORT: '/api/school/homework/mostwronganswers',
    HOMEWORK_ALL_QUESTIONS_REPORT: '/api/school/homework/homeworkallquestionsreport',
    HOMEWORK_STATUS_WRONG_ANSWERS_REPORT: '/api/school/homework/status/mostwronganswers',
    HOMEWORK_ELO_REPORT: '/api/school/homework/eloreport',
    // TEST_ELO_REPORT: '/api/school/test/eloreport',
    TEST_ELO_REPORT: '/api/school/test/mocktesteloreport',
    TEST_ELO_REPORT_STUDENT_LIST: '/api/school/test/eloreport/studentlist',
    HOMEWORK_ELO_REPORT_STUDENT_LIST: '/api/school/homework/eloreport/studentlist',
    GET_IMD_REPORT: '/api/school/user/imd/report',
    GET_IMD_STUDENT_LIST: '/api/school/user/imd/student/list',
    GET_IMD_STUDENT_EVALUATION_REPORT: '/api/school/user/imd/student/evaluation/report',
    GET_IMD_NATIONAL_AVERAGE: '/api/school/user/imd/student/national/average',
    GET_IMD_PERFORMANCE_REPORT: '/api/school/user/imd/event/skill/wise/report',
    GET_IMD_PERFORMANCE_LIST: '/api/school/user/imd/event/skill/wise/student/list',
    GET_IMD_WINNERS_LIST: '/api/school/user/imd/winners/list',
    DOWNLOAD_ALL_PERFORMANCE_REPORTS: '/api/school/imd/download/reports',
    DOWNLOAD_ALL_CERTIFICATES: '/api/school/imd/download/certificates',
    DOWNLOAD_CERTIFICATE: '/api/school/imd/download/certificate',
    DOWNLOAD_TEACHER_CERTIFICATE: '/api/school/teacher/imd/download/certificate',
    SCHOOL_PDF_REPORT: '/api/school/event/report',
    ADD_EVENT_TO_SCHOOL: '/api/school/event/add',
    GET_EVENT_REPORT: '/api/school/user/event/report',
    GET_EVENT_CONSOLIDATED_REPORT: '/api/school/user/event/report/consolidated',
    GET_SURVEY_REPORT: '/api/school/survey/report',
    GET_EVENT_STUDENT_LIST: '/api/school/user/event/student/list',
    GET_EVENT_STUDENT_EVALUATION_REPORT: '/api/school/user/event/student/evaluation/report',
    GET_EVENT_NATIONAL_AVERAGE: '/api/school/user/event/student/national/average',
    GET_EVENT_PERFORMANCE_REPORT: '/api/school/user/event/event/skill/wise/report',
    GET_EVENT_PERFORMANCE_LIST: '/api/school/user/event/event/skill/wise/student/list',
    GET_EVENT_AGGREGATE_BY_CLASS: '/api/school/user/event/aggregate/report/class',
    GET_EVENT_WINNERS_LIST: '/api/school/user/event/winners/list',
    STAFF_QUICK_SURVEY: '/api/school/staff/quicky/survey',
    GET_EVENTS: '/api/school/events',
    GET_EVENTS_LIST: '/api/school/events/list',
    USER_SCHOOL_APPROVAL_STATUS_UPDATE: '/api/school/user/approval/status',
    USER_SCHOOL_APPROVAL_BULK_UPDATE: '/api/school/user/approval/status/bulk',
    BULK_ASSIGN_CLASS_SECTION: '/api/school/user/assign/classsection/bulk',

    STUDENTS: '/api/users/list',
    HOMEWORK_DETAIL: '/api/school/homework/details',
    CHAPTER_HIERARCHY: '/api/school/homework/chapterhierarchy',
    CHAPTER_HIERARCHY_SEARCH: '/api/school/homework/chapterhierarchy/search',
    HOMEWORK_ELO_DETAILS: '/api/school/homework/elodetails',
    HOMEWORK_ELO_DETAILS_FOR_CLICKER_PRACTICE: '/api/school/homework/elodetailsforclickerpractice',
    PRACTICE_QUESTION_LIST: "/api/school/practiceQuestions/list",

    GET_COUPONS: '/api/coupon/list',
    GET_COUPON_DETAILS: "/api/school/coupon/detail",
    SUBSCRIPTION_PLAN_LIST: '/api/subscriptionplan/list',

    UPDATE_SCHOOL: '/api/school/update',
    UPDATE_SCHOOL_CLASS: '/api/school/update/class',
    UPDATE_SCHOOL_FOR_SUPER_ADMIN: '/api/school/update/super',
    SCHOOL_LIST_FOR_ADMIN: '/api/school/list/super',

    BOARD_LIST: '/api/board/list',

    ALL_STAFF_TYPES: '/api/school/staff/types/all',
    SCHOOL_TEMP: '/api/school/temp/create',
    FFL_CURRICULUM_DOWNLOAD: '/api/school/ffldownloaduserinfo/create',
    SEND_ERROR_LOGS: '/api/school/errorlogs',
    SCHOOL_TEMP_SIGNUP_OTP: '/api/school/temp/otp',
    SCHOOL_USERS_SIGNUP_OTP: '/api/school/staff/otp',
    SCHOOL_USERS_SIGNUP: '/api/school/staff/signup',
    APPROVE_SCHOOL_USER: '/api/school/staff/approve',

    UPDATE_INVITE: '/api/school/user/update/invite',
    SEND_INVITATION: '/api/school/user/send/invitation',
    SEND_PAT_NOTIFICATION: '/api/school/pat/notification',
    SEND_TEACHER_INVITATIONS: '/api/school/user/send/teacher/invitations',
    SEND_STUDENT_INVITATIONS: '/api/school/user/send/student/invitations',
    SEND_EXISTING_STUDENT_INVITATIONS: '/api/school/user/send/existing/student/invitations',

    MISC: "/api/school/misc",
    STAFF_SCHOOL_DETAILS: "/api/school/staff/details",

    TEST: "/api/school/test",
    TEST_QUESTION_LIST: "/api/school/test/questions",
    DIAGNOSTIC_QUESTION_LIST: "/api/school/diagnostic/questions",
    TEST_COMPLETION_REPORT: "/api/school/test/report/completion",
    TEST_RESULT: '/api/school/test/report/result',
    TEST_WRONG_ANSWERS_REPORT: "/api/school/test/mostwronganswers",
    TEST_STATUS_WRONG_ANSWERS_REPORT: '/api/school/test/status/mostwronganswers',
    TEST_STUDENT_DETAIL_REPORT: "/api/school/test/stduentdetail",
    TEST_ALL_QUESTIONS_REPORT: "/api/school/test/allquestions",

    SCHOOL_USERS_UPGRADED: "/api/school/schoolusers/alreadyupgraded",
    GET_DISCOUNT_DETAILS: "/api/web/users/claim/discount",
    CLAIM_DETAILS: "/api/school/users/claim/details",

    USER_ASSESSMENT_ACTIVITY: "/api/school/user/assessment/activity",
    SCHOOL_CHAPTER_DETAIL_REPORT: "/api/school/chapters/report",
    SCHOOL_ASSESSMENT_QUESTION_SET: "/api/school/assessment/question/set",
    SCHOOL_QUESTION_SET_QUESTION: "/api/school/assessment/question/set/question",
    GET_SCHOOL_QUESTION_SET: "/api/school/assessment/question/set/content",
    PRACTICE_QUESTION_COMPLEXITY: "/api/school/practicequestioncomplexity",

    REWARD: "/api/school/reward",
    REWARD_ACTIVITY: "/api/school/reward/activity",
    VOUCHERS: "/api/school/vouchers",
    VOUCHER_PURCHASE_HISROTY: "/api/school/vouchers/history",
    ADD_VIDEO_WATCHED_REWARD_POINT: "/api/school/addvideowatchedrewardpoint",

    VIDEO_CONTENT_SEARCH: "/api/school/learningresources/chapter/videolearningcontent/search",

    PASSCODE_UPDATE: '/api/school/student/passcode',

    GENERATE_PDF: '/api/school/generatePdf',
    GENERATE_CASE_STUDY_PDF: '/api/school/generatecasestudypdf',

    GET_COMPREHENSION_KEYWORDS: '/api/school/comprehensionkeywords/list',

    ALL_VIDEOS_LIST: '/api/school/allvideos/list',
    ALL_ELOS_LIST: '/api/school/allelos/list',

    VIDEO_SCHOOL_ASSIGNMENT: "/api/school/videoschoolassignment",
    VIDEO_SCHOOL_ASSIGNMENT_USING_MOBILE_NUMBER: '/api/school/videoschoolassignmentusingmobilenumber',
    VIDEO_SCHOOL_ASSIGNMENT_TO_TEACHER_USING_MOBILE_NUMBER: '/api/school/videoschoolassignmenttoteacherusingmobilenumber',


    WORKSHEET_CHAPTER_LIST: '/api/school/worksheetchapterlist',

    CLASS_ENGAGEMENT_LIST: '/api/school/classengagementlist',
    STUDENT_ENGAGEMENT_SCORE_RANKING: '/api/school/studentengagementscore/ranking',

    PERFORMANCE_REPORT: '/api/school/classperformancereport',
    STUDENT_DIAGNOSTIC_REPORT_PDF: '/api/school/studentdiagnosticreportpdf',


    GET_SCHOOL_BOARD_CLASS: '/api/school/boardandclass',
    GET_SCHOOL_CLASS_SECTION: '/api/school/class/section',
    GET_SCHOOL_ASSESSMENT_QUESTIONS: '/api/school/assessment/allquestions',
    CREATE_ASSESSMENT: '/api/school/create/assessment',

    TEACHER_HOMEWORK_ACTIVITY: '/api/school/staff/homework/activity',

    CATEGORY_THEME_LIST: '/api/studentPortalThemes/list',
    CONFIGURATIONS_LIST: '/api/configurations/list',


    MY_CLICKER_ASSESSMENT_INFO: "/api/school/clicker/assessment/info",
    MY_CLICKER_ASSESSMENT: '/api/school/clicker/assessment',
    HOMEWORK_ASSESSMENT_CONTENTS: '/api/school/homework/test/contents',

    STUDENTS_CLICKER_LIST: '/api/school/student/clicker/list',

    // USER_DIAGNOSTIC_ASSESSMENT_ACTIVITY: "/api/school/user/diagnostic/assessment/activity",

    // Offline homework

    DOWNLOAD_OFFLINE_USER_ASSESSMENT_ACTIVITY: '/api/school/offline/user/assessment/activity/download',
    SYNC_OFFLINE_USER_ASSESSMENT_ACTIVITY: '/api/school/offline/user/assessment/activity/sync',
    DOWNLOAD_QUESIONWISE_PERCENTAGE_REPORT: '/api/school/clicker/assessment/questionwise/percentage/info',

    GET_ALL_STUDENT_PERFORMANCE_PDF: '/api/school/downloadallstudentsdiagnosticreportpdf',

    CREATE_CLICKER_QUIZ: '/api/school/create/clickerquiz',
    MY_CLICKER_ASSESSMENT_LEADERBOARD: '/api/school/clicker/assessment/leaderboard',

    HOMEWORK_FOR_CLICKER_PRACTICE: '/api/school/homeworkforclickerpractice',
    MY_HOMEWORK_PRACTICE_LEADERBOARD: '/api/school/clicker/homeworkpractice/leaderboard',
     GET_TEACHER_HOMEWORK_ACTIVITY: '/api/school/clicker/teacherhomeworkactivity',

    BASELINE_FINISHLINE_STUDENT_LIST : '/api/school/clicker/homeworkpractice/baselinefinishline/studentlist',
    BASELINE_FINISHLINE_STUDENT_REPORT : '/api/school/clicker/homeworkpractice/baselinefinishline/studentreport',
    BASELINE_FINISHLINE_CLASS_PERFORMANCE_REPORT : '/api/school/clicker/homeworkpractice/baselinefinishline/classperformancereport',

    HOMEWORK_STATUS: '/api/school/staff/homework/status',

    STANDARD_HOMEWORK_CLICKER_PRACTICE_ASSESSMENT: "/api/school/staff/standard/clickerpractice/assessment/content",
    VALIDATE_ANSWER_HOMEWORK_CLICKER_PRACTICE_ASSESSMENT: '/api/school/staff/clickerpractice/assessment/validate/answer',
    UPDATE_USER_HOMEWORK_CLICKER_PRACTICE_ACTIVITY: "/api/school/staff/standard/homework/clickerpractice/update/acticity",
    ASSESS_STANDARD_HOMEWORK_CLICKER_PRACTICE: "/api/school/staff/standard/homework/clickerpractice/nodeassessment",
    DOWNLOAD_OFFLINE_USER_CHAPTER_HOMEWORK: '/api/school/offline/user/chapter/homework/download',
    PRACTICE_HOMEWORK_STANDARD_COMPETENCY_REPORT: '/api/school/staff/standard/homework/clickerpractice/standardcompetencyreport',
    STUDENT_HOMEWORK_PRACTICE_REPORT_PDF: '/api/school/studenthomeworkpracticereportpdf',
    CLASS_PERFORMANCE_REPORT: '/api/school/student/classperformancereport',
    OVERALL_CLASS_PERFORMANCE_REPORT: '/api/school/student/overallclassperformancereport',
    SCHOOLWORK_OVERALL_CLASS_PERFORMANCE_REPORT: '/api/school/student/schoolwork/overallclassperformancereport',

    CLASS_SPECIFIC_PRACTICE_REPORT_PDF: '/api/school/staff/standard/homework/classspecific/standardcompetencyreport',
    STUDENT_CLASS_SPECIFIC_PRACTICE_REPORT_PDF: '/api/school/studentclassspecificpracticereportpdf',

    GET_QUESTIONS_LIST_PDF: '/api/school/test/downloadquestionlistpdf',

    GET_QUESTION_SET_LIST: '/api/school/test/questionsetlist',

    GET_CLICKER_SET_LIST: '/api/school/clicker/setlist',
    CLICKER_SET: '/api/school/clickerset',
    UPDATE_CLICKER_SET: '/api/school/clickerset/clickeridupdate',
    GET_CLICKER_INFO: '/api/school/clickerset/clickerInfo',

    USER_CLICKER_LIST: '/api/school/user/clicker/list',
    UPDATE_HOMEWORK_CLICKER_PRACTICE: '/api/school/clicker/homeworkpractice',
    UPDATE_HOMEWORK_NODES_CLICKER_PRACTICE: '/api/school/clicker/homeworkpractice/homeworknodes',

    UPDATE_CLICKER_SCHOOL_ASSESSMENT: '/api/school/clicker/schoolassessment',

    SYNC_OFFLINE_USER_CLICKER_PRACTICE_ACTIVITY : '/api/school/offline/user/clickerpractice/activity/sync',

    GET_CLASS_ASSIGNMENT_OVERVIEW : '/api/school/engagement/class/assignment/overview',
    GET_CLASS_ASSIGNMENT_DETAILS: '/api/school/engagement/class/assignment/details',

    STUDENT_HOMEWORK_REPORT : '/api/school/homework/student/performancereport',

    STUDENT_ENGAGEMENT_REPORT :'/api/school/student/engagementreport',

    HOMEWORK_CHAPTER_QUESTION_TYPE_SET_INFO : '/api/school/homework/chapter/questiontype/setinfo',
    APPLICATION_CONFIGUATION: '/api/school/applicationconfiguration',

};

export default Urls;
